<template>
    <div class="grid-table">
        <VueGoodTable
            :columns="columns" 
            :rows="rows"
            :line-numbers="true"
            :theme="theme"
            :max-height="`${maxHeight}px`"
            :row-style-class="rowStyleClassFn"
            :search-options="{
                enabled: true
            }"
            :select-options="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
            }"
            :pagination-options="{
                enabled: true,
                mode: 'pages',
            }"
            @on-row-click="onRowClick"
            @on-row-mouseenter="onRowMouseover"
            ref="vueTable"           
        >
        <template slot="table-row" slot-scope="props">
            <slot name="table-row" v-bind="props"></slot>
        </template>

        <template slot="table-column" slot-scope="props">
            <slot name="table-column" v-bind="props"></slot>
        </template>
        
        <!-- pagination -->
        <template
            slot="pagination-bottom"
            slot-scope="props"
        >
            <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap ">
                Showing 1 to
                </span>
                <b-form-select
                    :value="perPage"
                    :options="['3', '5','10','20','30']"
                    class="mx-1"
                    @input="(value)=>{
                        $emit('perPagePopping', value)
                        perPage = value
                        return props.perPageChanged({currentPerPage: value})
                    }"
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
                <b-pagination
                    :value="curPage"
                    :total-rows="props.total"
                    :per-page="perPage"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value)=>{
                        $emit('pagePopping', value)
                        return props.pageChanged({currentPage: value})
                    }"
                >
                <template #prev-text>
                    <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                    />
                </template>
                <template #next-text>
                    <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                    />
                </template>
                </b-pagination>
            </div>
            </div>
        </template>
          
        </VueGoodTable>
    </div>
</template>
<script>
import store from '@/store'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import { 
  // icon
  BIconFunnel, 
  BIconFunnelFill,
  // tag
  BFormGroup, 
  BFormInput,
  BCardTitle, 
  BCardSubTitle, 
  BFormSelect, 
  BPagination, 
  BDropdown, 
  BDropdownItem,
  BModal,
  BButton,
  BCol
} from 'bootstrap-vue'
import { Column } from './core.js'
import { watch, ref, getCurrentInstance, onMounted } from '@vue/composition-api'
export default {
    components: {
        VueGoodTable,
        BCardSubTitle,
        BCardTitle,
        BFormSelect,
        BPagination,
        BDropdown,
        BDropdownItem,
        BFormGroup, 
        BFormInput,
        BIconFunnel,
        BIconFunnelFill,
        BModal,
        BButton,
        BCol
    },
    props: {
        columns: {
            type: Array,
            default: ()=>[
                new Column('employee', '員工工號').SetMiddle(),
                new Column('department', '部門代號').SetMiddle()
            ]
        },
        rows: {
            type: Array,
            default: ()=>[
                { employee: '111113', department: '17002' },
                { employee: '110014', department: '17002' },
                { employee: '112024', department: '17002' },
                { employee: '110001', department: '17002' },
            ]
        },
        curPage: {
            type: Number,
            default: 1
        },
        onRowClick: {
            type: Function,
            default: ()=>{}
        },
        maxHeight: {
            type: Number,
            default: 1000
        },
        rowStyleClassFn: {
            type: Function,
            default: ()=>{ return '' }
        },
        onRowMouseover: {
            type: Function,
            default: ()=>{}
        },
        pageCount : {
            type: Number,
            default: 10
        }
    },
    setup(props, ctx){
        const vue = getCurrentInstance();
        const perPage = ref(props.pageCount);
        const theme = ref(store.state.appConfig.layout.skin === 'dark' ? 'nocturnal' : '');

        onMounted(()=>{
            vue.refs.vueTable?.perPageChanged({currentPerPage: perPage.value});
        })

        watch(store.state.appConfig.layout, ()=>{
            theme.value = store.state.appConfig.layout.skin === 'dark' ? 'nocturnal' : ''
        })
        return {
            theme,
            perPage,
        }
    },
}
</script>
<style lang="scss" scoped>


</style>